(function () {
  angular
    .module('kareo.ui.shared.modules.regex.ssn-regex', [])
    .constant('SSN_REGEX', /^\d{3}-?\d{2}-?\d{4}$/);
})();
